import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useSound } from "@/lib/SoundContext";
import { CATEGORIES, SITE } from "@/data/content";

export function FridgeMark({ size = 26 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <rect x="12" y="4" width="40" height="56" rx="10" fill="#BFE6D2" stroke="#2B2320" strokeWidth="4.5" />
      <line x1="13" y1="26" x2="51" y2="26" stroke="#2B2320" strokeWidth="4.5" />
      <rect x="40" y="11" width="5" height="10" rx="2.5" fill="#2B2320" />
      <rect x="40" y="33" width="5" height="15" rx="2.5" fill="#2B2320" />
    </svg>
  );
}

export default function Nav() {
  const { enabled, toggle } = useSound();
  const navigate = useNavigate();
  return (
    <div className="fixed top-3 inset-x-0 z-50 flex justify-center pointer-events-none px-3">
      <nav className="pointer-events-auto flex items-center gap-1 sm:gap-2 bg-[#FFFDF6]/90 backdrop-blur border-[3px] border-ink rounded-full pl-3 pr-1.5 py-1.5 shadow-[0_5px_0_rgba(43,35,32,0.25)] max-w-full">
        <Link
          to="/"
          data-testid="nav-fridge-home"
          className="flex items-center gap-2 font-bold text-[13px] sm:text-sm tracking-wide pr-1"
        >
          <FridgeMark size={22} />
          <span className="hidden xs:inline sm:inline">{SITE.name}</span>
        </Link>
        <span className="w-[3px] h-5 bg-ink/20 rounded-full hidden sm:block" />
        <NavLink to="/fridge" testid="nav-fridge-link">FRIDGE</NavLink>
        <DropdownMenu>
          <DropdownMenuTrigger
            data-testid="nav-work-category"
            className="font-hand font-bold text-[13px] sm:text-[15px] px-2.5 py-1 rounded-full hover:bg-butter/60 transition-colors outline-none"
          >
            WORK ▾
          </DropdownMenuTrigger>
          <DropdownMenuContent
            sideOffset={10}
            className="border-[3px] border-ink rounded-2xl bg-[#FFFDF6] shadow-[0_6px_0_rgba(43,35,32,0.2)] min-w-[240px]"
          >
            {CATEGORIES.map((c) => (
              <DropdownMenuItem
                key={c.id}
                data-testid={`nav-work-${c.id}`}
                className="font-hand font-bold text-[15px] gap-3 py-2.5 cursor-pointer focus:bg-butter/50"
                onClick={() => navigate(c.route)}
              >
                <span className="w-3.5 h-3.5 rounded-full border-2 border-ink flex-none" style={{ background: c.dot }} />
                {c.kicker} — {c.title}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
        <NavLink to="/about" testid="nav-about-link">ABOUT</NavLink>
        <NavLink to="/contact" testid="nav-contact-link">CONTACT</NavLink>
        <button
          data-testid="sound-toggle-button"
          onClick={toggle}
          aria-label={enabled ? "Turn sound off" : "Turn sound on"}
          className="ml-0.5 flex items-center gap-1.5 font-hand font-bold text-[12px] sm:text-[13px] border-[3px] border-ink rounded-full px-2 py-1 bg-butter hover:bg-[#ffef9e] transition-colors shadow-[0_3px_0_rgba(43,35,32,0.35)] active:translate-y-[2px] active:shadow-none"
        >
          {enabled ? <Volume2 size={15} /> : <VolumeX size={15} />}
          <span className="hidden sm:inline">{enabled ? "SOUND ON" : "SOUND OFF"}</span>
        </button>
      </nav>
    </div>
  );
}

function NavLink({ to, testid, children }) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className="font-hand font-bold text-[13px] sm:text-[15px] px-2 py-1 rounded-full hover:bg-butter/60 transition-colors"
    >
      {children}
    </Link>
  );
}